import * as angular from 'angular';
import foldToASCII from 'data/foldToASCII';
import { UserProfileModalController } from './userProfileModal/UserProfileModalController';
import UserProfileModalView from './userProfileModal/UserProfileModalView.html';
import { addUsersMessageId } from 'modules/account/AccountService2';
import { ListApplicationFeatures } from './ListApplicationFeatures';
import { BlipStoreFeatures } from 'modules/blipStore/BlipStoreFeatures';
import { Contexts } from 'modules/core/ContextProcessorService';
import { TenantRoles } from 'modules/application/tenant/TenantService';
import { blipStoreStateExtensionsDetail, blipStoreStateName } from 'modules/blipStore';
import { logoutStateName } from 'modules/login';
import '!ng-cache-loader!./BlockedTenantAlert.html';
import '!ng-cache-loader!./ForbiddenUserAlertList.html';
import { ORGANIZATION_MOVING_CHATBOTS, ORGANIZATION_NOT_ALLOWED_ALERT, ORGANIZATION_NOT_ALLOWED_ALERT_CANCEL, ORGANIZATION_CHATBOTS_SEARCH, } from '../tenant/TenantSegmentEvents';
import { BOTSLIST_AIAGENT_CREATE_NOW_CLICKED, BOTSLIST_AIAGENT_GET_TO_KNOW_CLICKED, BOTSLIST_CONTRACTPANNEL_CLICKED, BOTSLIST_CREATE_CONTACT_BUTTON_CLICKED, BOTSLIST_FORUM_CLICKED, BOTSLIST_HELPCENTER_CLICKED, BOTLIST_PRODUCT_UPDATES_CLICKED, } from './ListApplicationSegmentEvents';
import { applicationCreateMarketplaceStateName } from '../create';
import { blipDomainUrl, blipForumUrl, blipHelpcenterUrl, blipWebsocketHostName, blipWebsocketHostNameTenant, messaginghubWebsocketHostName, messaginghubWebsocketHostNameTenant, portalDomain, tenantRoute, } from 'app.constants';
import { TenantFeatures } from 'modules/application/tenant/TenantFeatures';
import { aiAgentsDiscoveryStateName, selectWhichCreationRouteToRedirect } from '../create/steps/aiAgent';
import { CrossAppFeatures } from 'modules/shared/featureToggle/CrossAppFeatures';
import { FeatureToggleClientService } from 'feature-toggle-client';
import { MessagingHubFeatures } from 'modules/messaginghub/MessagingHubFeatures';
import { productUpdatesStateName } from '../productUpdates';
import { BuilderFeatures } from '../detail/portal-submodule-builder/templates/builder/BuilderFeatures';
import StudioTrialModal from '../detail/portal-submodule-builder/templates/builder/studio/components/StudioTrialModal';
import { ContractActivationOrigins } from '../detail/portal-submodule-builder/templates/builder/studio/services/StudioSegmentService';
export const OnSeachEvent = 'OnSeachEvent';
// Local storage
export const LSAddedToNotificationList = 'blip-portal:addedToNotificationList'; // LS = local storage
const FORBIDDEN_USER_ALERT_CANCEL = 'application-forbidden-user-alert-cancel';
const FORBIDDEN_USER_ALERT_REDIRECT = 'application-forbidden-user-alert-redirect';
const BLIP_STORE_PARAMETER_PORTAL_HOME_JOURNEY = 'PortalHome';
const BLIP_STORE_PARAM_HOME_ADDITIONAL_JOURNEY = 'PortalHomeAdditional';
const BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING = 'organization-home-blipstore-extension-get-to-know-clicked';
const BLIP_STORE_EXTENSION_RECOMMENDATION_CLICKED_TRACKING = 'organization-home-blip-store-free-trial-clicked';
const BLIP_STORE_MORE_CLICKED_TRACKING = 'organization-home-blip-explore-more-clicked';
const BLIP_CALLS_HOME_KNOW_MORE = 'blip-calls_home_knowMore';
const AI_AGENT = 'aiAgent';
const STUDIO_TRIAL_BANNER_REGISTER_PLAN_TRACKING = 'studio-trial-banner-register-plan-clicked';
const STUDIO_UPGRADE_BANNER_PLAN_CLICKED_TRACKING = 'studio-upgrade-banner-plan-clicked';
const STUDIO_TRIAL = 'trial';
const STUDIO_UPGRADE = 'upgrade';
export class ListApplicationController {
    static $inject = ['$state', '$rootScope', 'ApplicationService2', 'LoadingService', 'ngToast', '$translate', 'ModalService', 'AccountService2', 'BlipService', 'AuthenticationService', 'ContextProcessorService', '$stateParams', 'TenantService', 'SegmentService', 'BLIP_DOMAIN', '$window', 'SharedToastsService', '$location', 'TranslateService', 'ExternalBlipStoreService', 'StudioService', 'BlipToastService', 'BuilderAiAgentService'];
    constructor($state, $rootScope, ApplicationService2, LoadingService, ngToast, $translate, ModalService, AccountService2, BlipService, AuthenticationService, ContextProcessorService, $stateParams, TenantService, SegmentService, BLIP_DOMAIN, $window, SharedToastsService, $location, TranslateService, ExternalBlipStoreService, StudioService, BlipToastService, BuilderAiAgentService) {
        'ngInject';
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.ApplicationService2 = ApplicationService2;
        this.LoadingService = LoadingService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.ModalService = ModalService;
        this.AccountService2 = AccountService2;
        this.BlipService = BlipService;
        this.AuthenticationService = AuthenticationService;
        this.ContextProcessorService = ContextProcessorService;
        this.$stateParams = $stateParams;
        this.TenantService = TenantService;
        this.SegmentService = SegmentService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.$window = $window;
        this.SharedToastsService = SharedToastsService;
        this.$location = $location;
        this.TranslateService = TranslateService;
        this.ExternalBlipStoreService = ExternalBlipStoreService;
        this.StudioService = StudioService;
        this.BlipToastService = BlipToastService;
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.defaultNotFoundMessage = 'listViewApplication.noneRegistered';
        this.noSearchResultsMessage = 'listViewApplication.chatbotNotFound';
        this.isQueryingApplications = false;
        this.isBannerBlipStoreEnabled = false;
        this.isCarouselBannerEnabled = false;
        this.useCarouselBanner = false;
        this.useAdditionalExtension = false;
        this.hasAiAgentsBots = false;
        this.skip = 1;
        this.isSkipPage = false;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.isItemPerPage = false;
        this.listItemsPerPage = [40, 80, 120];
        this.isRefreshing = false;
        this.showPagination = false;
        this.blipDomainUrl = blipDomainUrl;
        this.blipWebsocketHostName = messaginghubWebsocketHostNameTenant;
        this.blipWebsocketHostNameTenant = messaginghubWebsocketHostNameTenant;
        this.portalDomain = portalDomain;
        this.isBannerBlipCallsEnabled = false;
        this.isBannerBlipStoreFlagEnabled = false;
        this.cardProductUpdatesIsEnabled = false;
        this.isStudioTrialEnabled = false;
        this.isShouldShowStudioTrialRegister = false;
        this.isShouldShowStudioTrialUpdate = false;
        this.isUpdatePlanModalOpen = false;
        this.isApplicationBlocked = (application) => {
            if (this.isMovingChatbots) {
                return !this.adminApplications.some(aa => aa === application.shortName);
            }
            else if (this.ContextProcessorService.context === Contexts.Default) {
                return false;
            }
            else {
                return !application.hasPermission;
            }
        };
        this.setTotalPagination = () => {
            this.LoadingService.startLoading();
            const total = this.totalApplications = this.isQueryingApplications ? this.searchResults.length : this.applicationsBuffer.length;
            this.totalNumberPages = total ? Math.ceil(total / this.itemsPerPage) : 1;
            this.totalNumberItems = total ? total : 0;
            this.loadPerItem();
            this.LoadingService.stopLoading();
        };
        this.onChangePage = async (event) => {
            const value = event.detail;
            this.isSkipPage = true;
            await this.refreshList(value);
        };
        this.refreshList = async (page) => {
            this.LoadingService.startLoading();
            if (this.isRefreshing) {
                return;
            }
            this.isRefreshing = true;
            try {
                if (this.isSkipPage) {
                    this.skip = (page - 1) * this.itemsPerPage;
                    this.page = page;
                    await this.loadSkipPage();
                }
            }
            finally {
                this.isRefreshing = false;
                this.LoadingService.stopLoading();
            }
        };
        this.onChangeItemPerPage = async (itemsPerPage, skip) => {
            this.itemsPerPage = typeof itemsPerPage === 'string' ? Number(itemsPerPage) : itemsPerPage;
            this.totalNumberPages = 0;
            this.totalNumberItems = 0;
            this.setTotalPagination();
        };
        this.onChangeItem = (event) => {
            const value = event.detail;
            this.itemsPerPage = typeof value === 'string' ? Number(value) : value;
            this.onChangeItemPerPage(this.itemsPerPage, 1);
        };
        this.getPaginationLabel = () => {
            return {
                start: ((this.page - 1) * this.itemsPerPage + 1),
                end: (this.page * this.itemsPerPage < this.totalApplications ? this.page * this.itemsPerPage : this.totalApplications),
                total: this.totalApplications,
            };
        };
        this.confirmStartTrial = async () => {
            await this.handleStudioAction(STUDIO_TRIAL);
        };
        this.confirmUpgradeTrial = async () => {
            await this.handleStudioAction(STUDIO_UPGRADE);
        };
        this.closeModal = () => {
            this.isUpdatePlanModalOpen = false;
        };
        this.noSearchResults = false;
        this.$rootScope.$on(OnSeachEvent, (_, text) => this.onSearchBots(text));
        this.tenantId = this.$stateParams['tenant-invitation'];
        this.tenantName = this.$stateParams.tenantName && decodeURIComponent(this.$stateParams.tenantName);
        this.applicationShortName = this.$stateParams.shortName;
        this.emailOwner = '';
        this.unsubscribe = this.StudioService.onStatusChange(() => {
            this.configureStudioTrialBanners();
        });
    }
    get notFoundMessage() {
        return this.noSearchResults
            ? this.noSearchResultsMessage
            : this.defaultNotFoundMessage;
    }
    async $onInit() {
        this.account = await this.AccountService2.me();
        this.LoadingService.startLoading(false);
        this.isPaginationHomeInApplication = await TenantFeatures.paginationHomeInApplication();
        await this.ContextProcessorService.waitForInitialization();
        this.featureFlags = FeatureToggleClientService.getInstance().getUserInstance().allFlags();
        this.language = this.TranslateService.getCurrentLanguage();
        this.token = this.AuthenticationService.token;
        this.authEmail = this.AuthenticationService.email;
        const useDelegation = await MessagingHubFeatures.GetMessagingHubCommandWithDelegation();
        this.blipWebsocketHostName = useDelegation ? blipWebsocketHostName : messaginghubWebsocketHostName;
        this.blipWebsocketHostNameTenant = useDelegation ? blipWebsocketHostNameTenant : messaginghubWebsocketHostNameTenant;
        this.cluster = this.ContextProcessorService.PORTALDOMAIN.replace('https://', '').split('.')[0];
        try {
            await this.checkFeatures();
            await this.getBlipAccount();
            /**
             * Show user profile modal
             */
            if (this.userProfileModalEnabled) {
                if (await this.BlipService.isConnected()) {
                    /**
                     * Verify if is old user and has no profile defined
                     */
                    if (!this.blipAccount
                        || !this.blipAccount.extras
                        || (!this.blipAccount.extras.userProfile && !this.isOrganizationEnabled)
                        || (!this.blipAccount.extras.userProfile && this.isOrganizationEnabled && this.blipAccount.extras.isOldUser)) {
                        this.ModalService.showModal({
                            template: UserProfileModalView,
                            controller: UserProfileModalController,
                            controllerAs: '$ctrl',
                        });
                    }
                }
            }
            const userAddedToNotificationListKey = `${LSAddedToNotificationList}-${this.AuthenticationService.email}`;
            if (localStorage.getItem(userAddedToNotificationListKey) !== 'true') {
                // Add user to portal broadcast list for notifications bot
                this.addUserToNotificationsBroadcastList();
                localStorage.setItem(userAddedToNotificationListKey, 'true');
            }
            await this.getBlipAccount();
            if (this.isOrganizationEnabled) {
                const userIdentity = `${encodeURIComponent(this.blipAccount.email)}@${this.BLIP_DOMAIN}`;
                /**
                 * Try to get tenant id for logged user
                */
                if (this.tenantId) {
                    const tenantId = this.ContextProcessorService.tenant.id;
                    this.userTenant = await this.TenantService.getTenantUser(tenantId, userIdentity);
                    try {
                        if (this.userTenant.userStatus == 'PendingUser') { // TODO: enumerator was getting conflict with angularjs
                            await this.TenantService.setMemberStatus(this.tenantId, userIdentity, 'accepted');
                        }
                        this.$window.location.href = this.TenantService.getTenantUrl(this.tenantId, true);
                    }
                    catch (e) {
                        console.log(e);
                        const error = JSON.parse(e);
                        if (error.reason.code == 67) {
                            this.notAllowedAlertToggle();
                        }
                        else {
                            console.error(e);
                        }
                    }
                }
                try {
                    if (this.ContextProcessorService.context === Contexts.Default) {
                        await this.configureApplicationsMigration();
                        this.canCreateChatBot = true;
                        await this.bindAllApplications();
                        await this.configPagination();
                        this.LoadingService.stopLoading();
                        return;
                    }
                    const tenantId = this.ContextProcessorService.tenant.id;
                    await this.bindBlipAccount();
                    this.canCreateChatBot = await this.TenantService.hasRequiredTenantRole(userIdentity, tenantId, [TenantRoles.Admin, TenantRoles.Member]);
                    if (this.isBlipStoreHomePortalPluginsRecommendationServicePageEnabled) {
                        const language = await this.TranslateService.getCurrentLanguage();
                        await this.GetExtensionsByParameter(language);
                    }
                    this.CheckCarouselBannerShouldBeActive();
                    if (this.isAdditionalPluginRecommendationsEnabled) {
                        const language = await this.TranslateService.getCurrentLanguage();
                        await this.GetAdditionalExtensionsByParameter(language);
                    }
                    if (await this.TenantService.hasRequiredTenantRole(userIdentity, tenantId, [TenantRoles.Admin])) {
                        this.applications = await this._loadApplications();
                        this.applications.reverse();
                        this.applicationsBuffer = this.applications;
                        await this.configPagination();
                        if (this.applications.length) {
                            await this.configureApplicationsMigration(tenantId);
                        }
                        return;
                    }
                    this.applicationsBuffer = undefined;
                    this.applications = await this.ApplicationService2.getApplications(tenantId);
                    this.applicationsBuffer = this.applications;
                    await this.configPagination();
                }
                catch (e) {
                    const errorMsg3 = await this.$translate('utils.errorMsg.3');
                    this.ngToast.danger(errorMsg3);
                    console.error(e);
                }
                finally {
                    this.isMovingChatbots = this.$stateParams.isMovingChatbots ? true : false;
                    this.LoadingService.stopLoading();
                }
            }
            else {
                this.canCreateChatBot = true;
                await this.bindAllApplications();
                await this.configPagination();
                this.LoadingService.stopLoading();
            }
        }
        catch (e) {
            console.error(e);
            const errorMsg3 = await this.$translate('utils.errorMsg.3');
            this.ngToast.danger(errorMsg3);
        }
        finally {
            this.LoadingService.stopLoading();
            if (this.$stateParams.forbidden) {
                const currentApplication = this.applications.filter(a => a.shortName == this.applicationShortName);
                if (currentApplication.length > 0) {
                    this.emailOwner = currentApplication[0].emailOwner;
                }
                await this.forbiddenUserAlertToggle();
            }
            await this.SharedToastsService.showLeaveContractToast();
        }
    }
    $onDestroy() {
        this.unsubscribe();
    }
    async configureApplicationsMigration(tenantId) {
        this.checkedApplications = [];
        this.adminApplications = await this.ApplicationService2.getAdminApplications(tenantId);
        this.canMigrateApplications = await ListApplicationFeatures.canMigrateBots();
    }
    async getBlipAccount() {
        this.blipAccount = await this.AccountService2.me();
    }
    async bindBlipAccount() {
        if (!this.blipAccount) {
            this.blipAccount = await this.AccountService2.me();
            const userExtras = this.isOrganizationEnabled
                ? { ...this.blipAccount.extras }
                : {
                    ...this.blipAccount.extras,
                    isOldUser: 'true',
                };
            await this.AccountService2.setExtras(userExtras);
        }
    }
    async bindAllApplications() {
        this.applications = await this.ApplicationService2.getApplications();
        this.applicationsBuffer = this.applications;
    }
    async checkFeatures() {
        try {
            this.isAiAgentEnabled = Boolean(this.ContextProcessorService.tenant.id) && await this.BuilderAiAgentService.validateContractStatus(this.ContextProcessorService.tenant.id);
            this.isPipelineEnabled = Boolean(await ListApplicationFeatures.isPipelineEnabled());
            [this.userProfileModalEnabled, this.isOrganizationEnabled, this.useFooterWithBlipStatus] = await Promise.all([
                ListApplicationFeatures.userProfileModalEnabled(),
                this.TenantService.isOrganizationEnabled(),
                CrossAppFeatures.useFooterWithBlipStatus(),
            ]);
            this.isBlipStoreHomePortalPluginsRecommendationServicePageEnabled = await BlipStoreFeatures.isBlipStoreHomePortalPluginsRecommendationServicePageEnabled();
            this.useCarouselBanner = await ListApplicationFeatures.isUseCarouselBanner();
            this.isAdditionalPluginRecommendationsEnabled = await ListApplicationFeatures.isAdditionalPluginRecommendationsEnabled();
            this.isBannerBlipCallsEnabled = await ListApplicationFeatures.isBannerBlipCallsEnabled();
            this.isBannerBlipStoreFlagEnabled = await ListApplicationFeatures.isBannerBlipStoreFlagEnabled();
            this.cardProductUpdatesIsEnabled = await ListApplicationFeatures.isCardProductUpdatesEnabled();
            this.isStudioTrialEnabled = await BuilderFeatures.isStudioCheckingEnabled();
            await this.configureStudioTrialBanners();
            this.CheckCarouselBannerShouldBeActive();
        }
        catch (e) {
            throw e;
        }
    }
    onSearchBots(text) {
        const searchText = foldToASCII(text).toLowerCase();
        this.searchText = text;
        this.noSearchResults = false;
        this.isQueryingApplications = true;
        if (!this.applicationsBuffer) {
            this.applicationsBuffer = angular.copy(this.applications);
        }
        if (searchText.length > 2) {
            const searchResults = this.applicationsBuffer.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            const tenant = this.isOrganizationEnabled && this.ContextProcessorService.tenant;
            if (tenant && tenant.id) {
                this.SegmentService.createTrack(ORGANIZATION_CHATBOTS_SEARCH, {
                    status: 'success',
                    organizationName: tenant.name,
                    organizationUrl: this.TenantService.getTenantUrl(tenant.id),
                    text: searchText,
                    qtdItens: searchResults.length,
                });
            }
            if (searchResults.length > 0) {
                this.applications = searchResults;
                this.searchResults = searchResults;
                this.configPagination();
            }
            else {
                this.applications = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.applications = this.applicationsBuffer;
            this.isQueryingApplications = false;
            this.searchResults = undefined;
            this.configPagination();
        }
    }
    async addUserToNotificationsBroadcastList() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
        await this.BlipService.sendMessage({
            type: 'text/plain',
            content: '#addlist',
            to: 'notifications@msging.net',
            id: addUsersMessageId,
        });
    }
    toggleIsMovingChatbots() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_MOVING_CHATBOTS);
        this.hasAiAgentsBots = this.applications.some((app) => app.template === AI_AGENT);
        this.isMovingChatbots = !this.isMovingChatbots;
    }
    async forbiddenUserAlertToggle() {
        this.SegmentService.createTrack(FORBIDDEN_USER_ALERT_CANCEL);
        const bdsAlert = document.querySelector('bds-alert[id=forbiddenUserAlertList]');
        await bdsAlert.toggle();
    }
    forbiddenUserAlertRedirect() {
        this.SegmentService.createTrack(FORBIDDEN_USER_ALERT_REDIRECT);
        this.$state.go(logoutStateName, { shortName: this.applicationShortName });
    }
    async notAllowedAlertToggle() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_NOT_ALLOWED_ALERT_CANCEL);
        const bdsAlert = document.querySelector('bds-alert[id=blockedTenant]');
        await bdsAlert.toggle();
    }
    notAllowedAlertRedirect() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_NOT_ALLOWED_ALERT);
        this.$state.go(logoutStateName, { tenantId: this.tenantId });
    }
    onCreateContactButtonClick() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_CREATE_CONTACT_BUTTON_CLICKED);
        this.$state.go(applicationCreateMarketplaceStateName);
    }
    onContractCardClick() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_CONTRACTPANNEL_CLICKED);
        window.location.href = tenantRoute;
    }
    onHelpCardClick() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_HELPCENTER_CLICKED);
        this.$window.open(blipHelpcenterUrl, '_blank');
    }
    onCommunityCardClick() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_FORUM_CLICKED);
        this.$window.open(blipForumUrl, '_blank');
    }
    onProductNewsCardClick() {
        this.SegmentService.createOrganizationTrack(BOTLIST_PRODUCT_UPDATES_CLICKED);
        this.$state.go(productUpdatesStateName);
    }
    getCurrentWorkspaceName() {
        return this.ContextProcessorService?.tenant.name
            || (this.blipAccount?.fullName || this.AuthenticationService?.auth?.account?.fullName);
    }
    async _loadApplications() {
        return await this.ApplicationService2.getApplicationsByTenant(this.ContextProcessorService.tenant.id);
    }
    async configPagination() {
        this.setInitPagination();
        this.setTotalPagination();
        this.validateMinimumToShowPagination();
    }
    async setInitPagination() {
        this.page = 1;
        this.totalNumberPages = 0;
        this.totalNumberItems = 0;
        this.itemsPerPage = 40;
    }
    async loadPerItem() {
        this.applications = this.isQueryingApplications ? this.searchResults : this.applicationsBuffer;
        this.applications = this.isPaginationHomeInApplication ? this.applications.filter((app, index) => index < this.itemsPerPage) : this.applications;
    }
    validateMinimumToShowPagination() {
        if (this.totalApplications > this.itemsPerPage) {
            this.showPagination = true;
        }
        if (this.itemsPerPage < this.totalApplications) {
            this.showPagination = true;
        }
    }
    async loadSkipPage() {
        this.applications = this.isQueryingApplications ? this.searchResults : this.applicationsBuffer;
        this.applications = this.applications.slice(this.skip, this.skip + this.itemsPerPage);
    }
    /**
     * Configures Studio trial banner display based on the current plan status.
     * Sets the appropriate banner flags (isShouldShowStudioTrialRegister, isShouldShowStudioTrialUpdate)
     * based on the centralized logic from StudioService.
     * @private
     */
    async configureStudioTrialBanners() {
        if (!this.isStudioTrialEnabled) {
            this.isShouldShowStudioTrialRegister = false;
            this.isShouldShowStudioTrialUpdate = false;
            return;
        }
        try {
            const bannerInfo = await this.StudioService.getBannerDisplayInfo();
            this.isShouldShowStudioTrialRegister = bannerInfo.shouldShowTrialBanner;
            this.isShouldShowStudioTrialUpdate = bannerInfo.shouldShowUpgradeBanner;
            await this.StudioService.trackStudioActivation(ContractActivationOrigins.ApplicationList);
            if (this.isShouldShowStudioTrialRegister) {
                bannerInfo.shouldShowTrialBanner;
            }
            else if (this.isShouldShowStudioTrialUpdate) {
                bannerInfo.shouldShowUpgradeBanner;
            }
            else {
                return;
            }
        }
        catch (error) {
            console.error('Error checking Studio status:', error);
            this.isShouldShowStudioTrialRegister = false;
            this.isShouldShowStudioTrialUpdate = false;
        }
    }
    /**
     * Handles Studio trial and upgrade actions with unified logic
     * @private
     * @param action - The action type: 'trial' for starting trial, 'upgrade' for upgrading plan
     */
    async handleStudioAction(action) {
        if (action === 'trial') {
            await this.StudioService.applyTrialToTenant({ origin: 'banner' });
            this.SegmentService.createTrack(STUDIO_TRIAL_BANNER_REGISTER_PLAN_TRACKING);
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('studioTrial.start.toasts.success'),
            });
        }
        else if (action === 'upgrade') {
            this.SegmentService.createTrack(STUDIO_UPGRADE_BANNER_PLAN_CLICKED_TRACKING);
            this.BlipToastService.show('success', {
                title: this.$translate.instant('updatePlanModal.toasts.success.title'),
                msg: this.$translate.instant('updatePlanModal.toasts.success.message'),
            });
        }
    }
    onClickToKnowAgent() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_AIAGENT_GET_TO_KNOW_CLICKED);
        this.$state.go(aiAgentsDiscoveryStateName, '_blank');
    }
    async onClickCreateAgent() {
        this.SegmentService.createOrganizationTrack(BOTSLIST_AIAGENT_CREATE_NOW_CLICKED);
        const pathToRedirect = await selectWhichCreationRouteToRedirect();
        this.$state.go(pathToRedirect, '_blank');
    }
    CheckCarouselBannerShouldBeActive() {
        this.isCarouselBannerEnabled =
            this.isAiAgentEnabled ||
                (this.isBannerBlipStoreEnabled && this.useCarouselBanner) ||
                this.isBannerBlipCallsEnabled ||
                this.isShouldShowStudioTrialRegister ||
                this.isShouldShowStudioTrialUpdate;
    }
    async GetExtensionsByParameter(language) {
        const extensionTenantId = this.tenantId == undefined ? this.ContextProcessorService.tenant.id : this.tenantId;
        this.extensions = await this.ExternalBlipStoreService.GetExtensionsByParameter(extensionTenantId, language, BLIP_STORE_PARAMETER_PORTAL_HOME_JOURNEY);
        if (this.isBannerBlipStoreFlagEnabled && this.extensions !== undefined && this.extensions.length > 0) {
            this.extension = this.extensions[0];
            this.isBannerBlipStoreEnabled = true;
        }
        else {
            this.isBannerBlipStoreEnabled = false;
        }
    }
    async GetAdditionalExtensionsByParameter(language) {
        const extensionTenantId = this.tenantId == undefined ? this.ContextProcessorService.tenant.id : this.tenantId;
        this.additionalExtensions = await this.ExternalBlipStoreService.GetExtensionsByParameter(extensionTenantId, language, BLIP_STORE_PARAM_HOME_ADDITIONAL_JOURNEY);
        if (this.additionalExtensions !== undefined && this.additionalExtensions.length > 0) {
            this.additionalExtension = this.additionalExtensions[0];
            this.useAdditionalExtension = true;
        }
    }
    onOpenBlipStoreExtensionDetail() {
        this.SegmentService.createOrganizationTrack(BLIP_STORE_INDICATED_EXTENSION_CLICKED_TRACKING, {
            extensionId: this.extension.id,
            extensionName: this.extension.name,
        });
        this.$state.go(blipStoreStateExtensionsDetail, { id: this.extension.id });
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    onOpenBlipStoreExtensionRecommendationDetail() {
        this.SegmentService.createOrganizationTrack(BLIP_STORE_EXTENSION_RECOMMENDATION_CLICKED_TRACKING, {
            extensionId: this.additionalExtension.id,
            extensionName: this.additionalExtension.name,
        });
        this.$state.go(blipStoreStateExtensionsDetail, { id: this.additionalExtension.id });
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    onRedirectBlipStore() {
        this.SegmentService.createTrack(BLIP_STORE_MORE_CLICKED_TRACKING);
        this.$state.go(blipStoreStateName);
        window.dispatchEvent(new CustomEvent('mfe-route-change', { detail: '/blip-store' }));
    }
    onOpenBlipCalls() {
        const baseUrl = window.location.origin;
        this.$window.open(`${baseUrl}/application/tenant/calls/`, '_blank');
        this.SegmentService.createTrack(BLIP_CALLS_HOME_KNOW_MORE);
    }
    onStartPlan() {
        this.ModalService.showModal(StudioTrialModal({
            confirm: () => this.confirmStartTrial(),
        }));
    }
    onUpgradePlan() {
        this.isUpdatePlanModalOpen = true;
    }
}
ListApplicationController.$inject = ['$state', '$rootScope', 'ApplicationService2', 'LoadingService', 'ngToast', '$translate', 'ModalService', 'AccountService2', 'BlipService', 'AuthenticationService', 'ContextProcessorService', '$stateParams', 'TenantService', 'SegmentService', 'BLIP_DOMAIN', '$window', 'SharedToastsService', '$location', 'TranslateService', 'ExternalBlipStoreService', 'StudioService', 'BlipToastService', 'BuilderAiAgentService'];
